package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price

import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.jetbrains.compose.web.css.CSSSizeValue

enum class PriceTypeEnum(
    val value: Int,
):TitleEnum {
    INDIVIDUAL_PRICE(
        value = 2
    ),
    DISCOUNT(
        value =5
    );


    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                 INDIVIDUAL_PRICE -> strings.individualPrice
                DISCOUNT -> strings.discount
            }
        }

}